module.exports = __webpack_public_path__ + "static/media/AP1_4595-3.714bbf56.jpg";